var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleCheckYellowIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 86C66.7482 86 86 66.7482 86 43C86 19.2518 66.7482 0 43 0C19.2518 0 0 19.2518 0 43C0 66.7482 19.2518 86 43 86Z",
    fill: "#FFC535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1942 17.6706L77.6019 10.1456C76.594 9.13768 74.9144 9.13768 73.8395 10.1456L41.3877 43.6723L27.3454 29.8316C26.3375 28.8238 24.6578 28.8238 23.5829 29.8316L16.8641 36.4833C15.8562 37.4911 15.8562 39.1708 16.8641 40.1787L39.3049 62.4177C39.9096 63.0225 40.7159 63.2239 41.5221 63.1567C42.3283 63.2239 43.1346 63.0223 43.7393 62.4177L85.1942 21.4331C86.2021 20.358 86.2021 18.6783 85.1942 17.6706Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckYellowIc);
export default __webpack_public_path__ + "static/media/circle_check_yellow_ic.67625c819c6a21a994894eb2e3c0e4e0.svg";
export { ForwardRef as ReactComponent };